"use client";

import { useEffect } from "react";
import { prepareOfflineWorkspace } from "@/lib/offline/prepare";

const BEFORE_APP_REFRESH = "agronomy:before-app-refresh";

/** A synchronous veto works in installed PWAs without a native unload dialog. */
export function useAppRefreshBlocker(blocked: boolean) {
  useEffect(() => {
    if (!blocked) return;
    const preventRefresh = (event: Event) => event.preventDefault();
    window.addEventListener(BEFORE_APP_REFRESH, preventRefresh);
    return () => window.removeEventListener(BEFORE_APP_REFRESH, preventRefresh);
  }, [blocked]);
}

function requireSafeRefresh() {
  if (!navigator.onLine)
    throw new Error("Connect to the internet before refreshing.");
  if (
    !window.dispatchEvent(new Event(BEFORE_APP_REFRESH, { cancelable: true }))
  ) {
    throw new Error(
      "Finish saving or close your current draft, then try refreshing again.",
    );
  }
}

export async function prepareAppRefresh() {
  requireSafeRefresh();
  // This route intentionally serves a complete cached generation even online.
  // Prepare its replacement atomically; never clear caches or account data.
  if (
    window.location.pathname.replace(/\/$/, "") === "/field-work" &&
    "serviceWorker" in navigator
  ) {
    await prepareOfflineWorkspace();
  }
  requireSafeRefresh();
}
